import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CitiesApiService } from '@digilize/shared/data/services';
import { Option } from '@digilize/shared/definitions/src';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'bwc-city-input',
  templateUrl: './city-input.component.html',
  styleUrls: ['./city-input.component.scss'],
})
export class CityInputComponent implements OnInit, OnDestroy {
  private readonly citiesApi = inject(CitiesApiService);
  private readonly destroy$ = new Subject<void>();

  @Input() control!: FormControl<string>;
  @Input() placeholder = '';
  @Input() hasError = false;

  cityOptions: Option[] = [];

  ngOnInit(): void {
    this.citiesApi
      .getCities()
      .pipe(takeUntil(this.destroy$))
      .subscribe((names) => {
        this.cityOptions = names.map((name) => ({ id: name, text: name, val: name }));
      });

    this.control.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(() => {
      this.cityOptions = [...this.cityOptions];
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearchChanged(value: string): void {
    this.control.setValue(value ?? '');
  }

  onCitySelected(option: Option): void {
    this.control.setValue(option.text);
    this.control.markAsDirty();
  }
}
